export const getIsNodeConnected = (nodeId, edges) =>
  !!edges?.find(({ source }) => nodeId === source) || !!edges?.find(({ target }) => nodeId === target);
